import React, { Fragment, useState, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import CustomPagination from "../../pagination/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckCircle,
  faTimes,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Modal, ModalBody } from "reactstrap";
import swal from "sweetalert";
import "../AdminPages.css";

const MessageModal = ({ isOpen, setIsOpen, item, function1 }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>By Clicking OK the Contract for {item.name} will be Closed!!!</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
                marginTop: "16px",
              }}
            >
              <button
                onClick={() => function1(item.id, false)}
                className="admin-students-new-btn"
              >
                <FontAwesomeIcon icon={faCheck} />
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="drawer-btn-delete"
              >
                <FontAwesomeIcon icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

const ContractSetup = () => {
  const [districtName, setDistrictName] = useState();
  const [showDistrictNameContainer, setShowDistrictNameContainer] = useState(
    false
  );
  const [districtNameList, setDistrictNameList] = useState();
  const [districtID, setDistrictID] = useState();
  const [pageData, setPageData] = useState();
  const districtNameRef = useRef();
  const timeoutRef = useRef();
  const [districtNameLoading, setDistrictNameLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [clickedSchool, setClickedSchool] = useState();

  const getDistrictsList = (value) => {
    setDistrictNameLoading(true);
    setShowDistrictNameContainer(true);
    setDistrictNameList([]);
    GetAdminService.getDistrictsList(value)
      .then((data) => {
        setDistrictNameList(data?.data?.objects);
        setDistrictNameLoading(false);
      })
      .catch(() => {
        setDistrictNameLoading(false);
      });
  };

  const handleDistrictName = () => {
    clearTimeout(timeoutRef.current);
    setDistrictName(districtNameRef.current.value);
    if (!districtNameRef.current.value) {
      setShowDistrictNameContainer(false);
      setDistrictNameList([]);
      setPageData([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getDistrictsList(districtNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedDistrictName = (item) => {
    setDistrictID(item?.id);
    setDistrictNameList([item]);
    setShowDistrictNameContainer(false);
    setDistrictName(item.name);
    getDistrictPage(item?.id);
  };

  const getDistrictPage = (id) => {
    let obj = {
      district: id,
    };
    setLoading(true);
    GetAdminService.districtPage(obj)
      .then((data) => {
        setPageData(data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const changeSubscribe = (school_id, sub) => {
    setOpenMessageModal(false);
    let obj = {
      isSigned: sub,
    };
    setLoading(true);
    GetAdminService.subscribeContract(school_id, obj)
      .then(() => {
        getDistrictPage(districtID);
        setLoading(false);
        swal({
          text: sub
            ? "Contract Subscribed Successfully"
            : "Contract Unsubscribed Successfully",
          icon: "success",
          dangerMode: true,
          buttons: {
            confirm: true,
          },
          closeOnClickOutside: true,
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Contract Setup with Schools</h2>
            </div>

            <div className="admin-students-school-selector">
              <label>Select District</label>
              <div className="school-input-wrapper">
                <input
                  ref={districtNameRef}
                  type="text"
                  placeholder="Type to search district name..."
                  value={districtName}
                  onChange={handleDistrictName}
                  autoComplete="off"
                />
                {showDistrictNameContainer && (
                  <ul className="school-dropdown">
                    {districtNameLoading && <CustomLoader />}
                    {districtNameList?.length > 0 &&
                      districtNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedDistrictName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {loading ? (
              <div className="admin-page-section">
                <CustomLoader />
              </div>
            ) : (
              pageData && (
                <div className="admin-page-table-wrap">
                  <table className="admin-page-table">
                    {pageData?.result?.length > 0 && (
                      <thead>
                        <tr>
                          <th>School Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {pageData?.result?.map((item, index) => (
                        <tr key={item?.id || index}>
                          <td>{item?.name}</td>
                          <td>
                            {item?.isSigned ? (
                              <span className="admin-page-status">
                                Contract Signed
                              </span>
                            ) : (
                              <span
                                className="admin-page-status"
                                style={{
                                  background: "#fef2f2",
                                  color: "#b91c1c",
                                  borderColor: "#fecaca",
                                }}
                              >
                                Contract Unsigned
                              </span>
                            )}
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              <button
                                disabled={item?.isSigned}
                                className="admin-students-new-btn"
                                onClick={() => changeSubscribe(item.id, true)}
                              >
                                <FontAwesomeIcon icon={faCheckCircle} />
                                Subscribe Contract
                              </button>
                              <button
                                disabled={!item?.isSigned}
                                className="drawer-btn-delete"
                                onClick={() => {
                                  setOpenMessageModal(true);
                                  setClickedSchool(item);
                                }}
                              >
                                <FontAwesomeIcon icon={faTimesCircle} />
                                Unsubscribe Contract
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}

            {pageData && pageData?.page_list?.length > 1 && (
              <div className="admin-page-pagination">
                <CustomPagination
                  count={pageData && pageData}
                  pageValue={page}
                  setPage={setPage}
                />
              </div>
            )}

            {openMessageModal && (
              <MessageModal
                setIsOpen={setOpenMessageModal}
                isOpen={openMessageModal}
                item={clickedSchool}
                function1={changeSubscribe}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ContractSetup;
